<div class="preview-header">
  <div class="preview-header-title-row">
    <h1 class="preview-header-title">{{ title }}</h1>
    @if (showBadge) {
      <app-shared-button class="preview-header-badge" [fill]="true" (buttonClicked)="onBadgeClicked()">
        {{ badgeText }}
      </app-shared-button>
    }
  </div>
  <p class="preview-header-subtitle">
    {{ subTitle }}<strong>{{ subTitleBold }}</strong>
  </p>
  <ng-content></ng-content>
</div>
